module.exports = __webpack_public_path__ + "static/img/Warriors.521458e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Warriors.svg
// module id = i9qZ
// module chunks = 0